<template>
  <div class="user-page">
    <div class="container">
      <div class="handle-box">
        <el-input placeholder="请输入手机号" v-model="phone" class="search-input"></el-input>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search" :disabled="disfle" :loading="lod">搜索
        </el-button>
      </div>
      <el-table :data="tableData" border class="table table-then-card" ref="filterTable" v-loading="loading">
        <el-table-column prop="uid" label="ID" width="120" align="center"></el-table-column>
        <el-table-column prop="nickname" label="用户昵称" width="180"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="150"></el-table-column>
        <el-table-column prop="gender" label="性 别" width="100" align="center" class-name="mobile-hide">
          <template slot-scope="scope">
            <el-link :type="scope.row.gender == 1 ? 'primary' : 'danger'">{{
          scope.row.gender == 0 ? '未完善' : scope.row.gender == 1 ? '男' : '女' }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="头像(点击查看)" align="center" prop="avatarUrl" width="150" class-name="mobile-hide">
          <template slot-scope="scope">
            <el-image class="table-td-thumb" preview-teleported :src="scope.row.avatarUrlSigned"
              :preview-src-list="[scope.row.avatarUrlSigned]" :z-index="10">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="birthday" label="生 日" align="center" class-name="mobile-hide">
          <template slot-scope="scope">
            <span>{{
          scope.row.birthday != '' ? scope.row.birthday : '未完善' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="积分(100:1)" prop="integrate" width="150" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="注册时间" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间" align="center" class-name="mobile-hide"></el-table-column>
        <el-table-column label="操作" width="320" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-view" @click="handleLook(scope.$index, scope.row)">
              查看
            </el-button>
            <el-button type="text" icon="el-icon-edit-outline" style="color:green"
              @click="handleUp(scope.$index, scope.row)">
              修改
            </el-button>
            <el-button type="text" icon="el-icon-coin" style="color:#e6a23c"
              @click="handleIntegral(scope.$index, scope.row)">
              积分操作
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 手机端卡片列表 -->
      <div class="mobile-card-list" v-loading="loading">
        <div v-for="(row, idx) in tableData" :key="row.uid" class="mc-card">
          <div class="mc-thumb-area">
            <el-image class="mc-img" preview-teleported :src="row.avatarUrlSigned"
              :preview-src-list="[row.avatarUrlSigned]" :z-index="10" fit="cover">
              <div slot="error" class="mc-avatar-placeholder"><i class="el-icon-user-solid"></i></div>
            </el-image>
            <div class="mc-thumb-info">
              <div class="mc-title" style="margin-bottom:2px">{{ row.nickname }}</div>
              <div style="font-size:12px;color:#909399;">ID: {{ row.uid }}
                <el-link :type="row.gender == 1 ? 'primary' : 'danger'" style="font-size:12px;margin-left:6px">{{ row.gender == 0 ? '未完善' : row.gender == 1 ? '男' : '女' }}</el-link>
              </div>
            </div>
          </div>
          <div class="mc-grid-2">
            <div class="mc-row">
              <span class="mc-label">手机号</span>
              <span class="mc-value">{{ row.phone }}</span>
            </div>
            <div class="mc-row">
              <span class="mc-label">积分</span>
              <span class="mc-value mc-value-warning">{{ row.integrate || 0 }}</span>
            </div>
            <div class="mc-row">
              <span class="mc-label">生日</span>
              <span class="mc-value">{{ row.birthday || '未完善' }}</span>
            </div>
            <div class="mc-row">
              <span class="mc-label">注册时间</span>
              <span class="mc-value">{{ row.createTime }}</span>
            </div>
          </div>
          <div class="mc-actions">
            <el-button size="small" icon="el-icon-view" @click="handleLook(idx, row)">查看</el-button>
            <el-button size="small" type="primary" icon="el-icon-edit-outline" @click="handleUp(idx, row)">修改</el-button>
            <el-button size="small" type="warning" icon="el-icon-coin" @click="handleIntegral(idx, row)">积分操作</el-button>
          </div>
        </div>
        <div v-if="!loading && tableData.length === 0" style="text-align:center;color:#909399;padding:30px 0;">暂无数据</div>
      </div>
      <div class="pagination">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="page" :page-size="size"
          layout="total, prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="修改用户信息" :visible.sync="upg" :width="dialogWidth">
      <el-form label-position="left" :rules="rules" ref="upInfo" label-width="100px" :model="upInfo" status-icon>
        <el-form-item label="用户头像">
          <el-upload class="avatar-uploader" action="http://localhost:9001/utils/upload" name="file"
            :on-success="handleAvatarSuccess" :show-file-list="false" :limit="1" ref="upload1">
            <img v-if="upInfo.avatarUrlSigned || upInfo.avatarUrl" :src="upInfo.avatarUrlSigned || upInfo.avatarUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="用户昵称" prop="nickname">
          <el-input placeholder="请输入用户昵称" prefix-icon="el-icon-edit" v-model="upInfo.nickname"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input disabled prefix-icon="el-icon-edit" v-model="upInfo.phone"></el-input>
        </el-form-item>
        <el-form-item label="性 别" prop="gender">
          <el-radio v-model="upInfo.gender" :label="1">男</el-radio>
          <el-radio v-model="upInfo.gender" :label="2">女</el-radio>
        </el-form-item>
        <el-form-item label="生 日">
          <el-date-picker v-model="upInfo.birthday" value-format="yyyy-MM-dd" type="date" placeholder="请选择">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="积分">
          <el-input :value="upInfo.integrate" disabled></el-input>
          <div style="color:#909399;font-size:12px;line-height:1.5;">积分不可在此处直接修改，请使用操作列的“积分操作”功能进行增减，所有变动会写入积分明细。</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="subUp('upInfo')">确 定</el-button>
        <el-button @click="upg = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 积分操作弹窗 -->
    <el-dialog title="积分操作" :visible.sync="integralDialog" :width="dialogWidthSmall" @close="resetIntegralForm">
      <el-form label-position="left" label-width="90px" :model="integralForm" :rules="integralRules" ref="integralForm">
        <el-form-item label="用户">
          <span>{{ integralForm.nickname }}（{{ integralForm.phone }}）</span>
        </el-form-item>
        <el-form-item label="当前积分">
          <span style="color:#e6a23c;font-weight:600;">{{ integralForm.currentIntegrate }}</span>
        </el-form-item>
        <el-form-item label="操作类型" prop="type">
          <el-radio-group v-model="integralForm.type">
            <el-radio :label="1">赠送积分</el-radio>
            <el-radio :label="-1">扣减积分</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="积分数量" prop="num">
          <el-input-number v-model="integralForm.num" :min="1" :max="1000000" :step="10"></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="integralForm.remark" placeholder="请输入操作备注（会记录在积分明细）" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="integralSubmitting" @click="submitIntegral">确 定</el-button>
        <el-button @click="integralDialog = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="用户详细信息" :visible.sync="xx" :width="dialogWidth">
      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane label="收货地址" name="first">
          <el-table :data="addList" border class="table table-then-card">
            <el-table-column prop="name" label="收货人" width="120" align="center"></el-table-column>
            <el-table-column prop="address" label="收货地址"></el-table-column>
            <el-table-column prop="detailed" label="详细地址"></el-table-column>
            <el-table-column prop="phone" label="手机号" width="150"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="150"></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" width="150"></el-table-column>
          </el-table>
          <!-- 手机端卡片列表 - 收货地址 -->
          <div class="mobile-card-list">
            <div v-for="(row, idx) in addList" :key="idx" class="mc-card">
              <div class="mc-header">
                <span class="mc-title">{{ row.name }}</span>
                <span class="mc-subtitle">{{ row.phone }}</span>
              </div>
              <div class="mc-row">
                <span class="mc-label">收货地址</span>
                <span class="mc-value">{{ row.address }} {{ row.detailed }}</span>
              </div>
              <div class="mc-grid-2">
                <div class="mc-row">
                  <span class="mc-label">创建时间</span>
                  <span class="mc-value">{{ row.createTime }}</span>
                </div>
                <div class="mc-row">
                  <span class="mc-label">修改时间</span>
                  <span class="mc-value">{{ row.updateTime }}</span>
                </div>
              </div>
            </div>
            <div v-if="addList.length === 0" style="text-align:center;color:#909399;padding:20px 0;">暂无地址</div>
          </div>
          <div class="pagination">
            <el-pagination @current-change="handleCurrentChangeA" :current-page.sync="pageA" :page-size="sizeA"
              layout="total, prev, pager, next" :total="adds ? adds.length : 0">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="积分明细" name="yj">
          <el-table :data="Integrals" border v-loading="loadingI" class="table table-then-card">
            <el-table-column prop="orderNum" label="关联订单"></el-table-column>
            <el-table-column prop="Zt" label="状态" align="center" width="180">
              <template slot-scope="scope">
                <template v-if="scope.row.tranType == 1">
                  <el-tag effect="dark" type="danger">
                    支出
                  </el-tag>
                </template>
                <template v-if="scope.row.tranType == 2">
                  <el-tag effect="dark" type='success'>
                    收入
                  </el-tag>
                </template>
                <template v-if="scope.row.tranType == 3">
                  <el-tag effect="dark" type='warning'>
                    退回
                  </el-tag>
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="num" label="积 分" width="200" align="center"></el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
          </el-table>
          <!-- 手机端卡片列表 - 积分明细 -->
          <div class="mobile-card-list" v-loading="loadingI">
            <div v-for="(row, idx) in Integrals" :key="idx" class="mc-card">
              <div class="mc-header">
                <div class="mc-header-left">
                  <el-tag effect="dark" :type="row.tranType == 1 ? 'danger' : row.tranType == 2 ? 'success' : 'warning'" size="small">
                    {{ row.tranType == 1 ? '支出' : row.tranType == 2 ? '收入' : '退回' }}
                  </el-tag>
                  <span class="mc-title" :class="row.tranType == 1 ? 'mc-value-danger' : row.tranType == 2 ? 'mc-value-success' : 'mc-value-warning'">
                    {{ row.tranType == 1 ? '-' : '+' }}{{ row.num }}
                  </span>
                </div>
                <span class="mc-subtitle">{{ row.createTime }}</span>
              </div>
              <div class="mc-row" v-if="row.orderNum">
                <span class="mc-label">关联订单</span>
                <span class="mc-value">{{ row.orderNum }}</span>
              </div>
            </div>
            <div v-if="!loadingI && Integrals.length === 0" style="text-align:center;color:#909399;padding:20px 0;">暂无记录</div>
          </div>
          <div class="pagination">
            <el-pagination @current-change="handleCurrentChangeI" :current-page.sync="pageI" :page-size="sizeI"
              layout="total, prev, pager, next" :total="totalI">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import { queryUserList, updateByUserInfo, querySearchUserPhone, queryUserIntegral, queryUserAddress, adjustUserIntegral } from '@/api';
export default {
  name: "UserAdmin",
  data() {
    return {
      imgUrl: '',
      xx: false,
      activeName: 'first',
      loading: true,
      loadingI: true,
      disfle: true,
      lod: false,
      uid: null,
      //用户表
      tableData: [],
      //用户收货地址
      adds: [],
      pageA: 1,
      sizeA: 5,
      //用户积分明细
      Integrals: [],
      pageI: 1,
      sizeI: 5,
      totalI: 0,
      page: 1,
      size: 10,
      total: 0,
      upg: false,
      upInfo: {},
      //积分操作弹窗
      integralDialog: false,
      integralSubmitting: false,
      integralForm: {
        uid: '',
        nickname: '',
        phone: '',
        currentIntegrate: 0,
        type: 1,
        num: 10,
        remark: ''
      },
      integralRules: {
        num: [
          { required: true, message: '请输入积分数量', trigger: 'blur' },
          { type: 'number', min: 1, message: '数量必须大于 0', trigger: 'blur' }
        ],
        remark: [
          { max: 30, message: '备注最多 30 个字符', trigger: 'blur' }
        ]
      },
      //搜索
      phone: '',
      rules: {
        nickname: [
          { required: true, message: "请输入账号", trigger: "blur" }
        ],
        avatarUrl: [
          { required: true, message: "请上传头像", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    dialogWidth() {
      return window.innerWidth < 768 ? '95%' : '75%';
    },
    dialogWidthSmall() {
      return window.innerWidth < 768 ? '95%' : '420px';
    },
    addList() {
      return this.adds
        ? this.adds.slice(
          (this.pageA - 1) * this.sizeA,
          this.pageA * this.sizeA
        )
        : [];
    }
  },
  watch: {
    phone: {
      handler(val) {
        if (val) {
          this.disfle = false
        } else {
          this.disfle = true
          this.getUserPage();
        }
      }
    }
  },
  methods: {
    //查看
    handleLook(index, row) {
      this.xx = true;
      let uid = row.uid;
      this.uid = uid;
      this.getUserAddress(uid);
      this.getUserIntegral(uid);
    },
    //收货地址分页
    handleCurrentChangeA(val) {
      this.pageA = val;
    },
    handleCurrentChangeI(val) {
      this.pageI = val;
      this.getUserIntegral(this.uid);
    },
    //获取收货地址
    getUserAddress(uid) {
      queryUserAddress({ uid }).then((res) => {
        let { code, data } = res;
        if (code != 0) {
          this.$message.error('获取地址失败');
          return false;
        }
        this.adds = data;
      })
    },
    //获取用户积分明细
    async getUserIntegral(uid) {
      this.loadingI = true;
      let pageNum = this.pageI;
      let pageSize = this.sizeI;
      let res = await queryUserIntegral({ pageNum, pageSize, uid });
      this.Integrals = res.list;
      this.totalI = res.total;
      setTimeout(() => {
        this.loadingI = false;
      }, 300)
    },
    //搜索
    handleSearch() {
      let phone = this.phone;
      this.page = 1;
      this.loading = true;
      this.lod = true;
      querySearchUserPhone({ phone }).then((res) => {
        let { data } = res;
        setInterval(() => {
          this.lod = false
          this.loading = false
        }, 300)
        this.tableData = data;
        this.total = data.length;
      }).catch(() => {
        this.$message.error('服务器错误');
      })
    },
    //上传头像：后端返回 { key: objectKey, url: 预签名URL }
    handleAvatarSuccess(res, file) {
      if (res.code != 0) {
        this.$message.warning('上传失败');
      } else {
        const data = res.data || {};
        this.$set(this.upInfo, 'avatarUrl', data.key);
        this.$set(this.upInfo, 'avatarUrlSigned', data.url);
        this.$refs.upload1.clearFiles()
      }
    },
    //向后端传入修改的数据
    subUp(formName) {
      this.$refs[formName].validate((volid) => {
        if (volid) {
          this.$confirm("是否确定修改该用户信息?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            updateByUserInfo(this.upInfo).then((res) => {
              let { code, msg } = res;
              if (code != 0) {
                this.$message.warning(msg);
                return false
              }
              this.upg = false;
              this.upInfo = {};
              this.getUserPage();
              this.$message.success(msg);
            })
          })

        } else {
          return false;
        }
      })
    },
    //打开积分操作弹窗
    handleIntegral(index, row) {
      this.integralForm = {
        uid: row.uid,
        nickname: row.nickname,
        phone: row.phone,
        currentIntegrate: row.integrate || 0,
        type: 1,
        num: 10,
        remark: ''
      };
      this.integralDialog = true;
      this.$nextTick(() => {
        this.$refs.integralForm && this.$refs.integralForm.clearValidate();
      });
    },
    resetIntegralForm() {
      this.$refs.integralForm && this.$refs.integralForm.clearValidate();
    },
    //提交积分调整
    submitIntegral() {
      this.$refs.integralForm.validate((valid) => {
        if (!valid) return false;
        const form = this.integralForm;
        const delta = form.type === 1 ? form.num : -form.num;
        const tip = form.type === 1
          ? `确认给用户赠送 ${form.num} 积分？`
          : `确认扣减用户 ${form.num} 积分？`;
        this.$confirm(tip, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.integralSubmitting = true;
          adjustUserIntegral({
            uid: form.uid,
            num: delta,
            remark: form.remark
          }).then((res) => {
            this.integralSubmitting = false;
            const { code, msg } = res;
            if (code != 0) {
              this.$message.warning(msg || '操作失败');
              return false;
            }
            this.$message.success(msg || '操作成功');
            this.integralDialog = false;
            this.getUserPage();
          }).catch(() => {
            this.integralSubmitting = false;
            this.$message.error('服务器错误');
          });
        }).catch(() => {});
      });
    },
    //修改
    handleUp(index, row) {
      let upInfo = JSON.stringify(row);
      this.upInfo = JSON.parse(upInfo);
      this.upg = true;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getUserPage();
    },
    async getUserPage() {
      try {
        this.loading = true;
        let pageNum = this.page;
        let pageSize = this.size;
        let res = await queryUserList({ pageNum, pageSize });
        this.tableData = res.list;
        this.total = res.total;
        setTimeout(() => {
          this.loading = false;
        }, 500)
      } catch (error) {
        this.$message.error('服务器错误');
      }
    }
  },
  created() {
    this.imgUrl = this.$base.url;
    this.getUserPage();
  },
};
</script>

<style scoped>
.user-page {
  height: calc(100vh - 110px);
  overflow-y: auto;
}

.pp {
  margin-top: 10px;
  float: right;
  color: #909399;
}

.handle-box {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input {
  width: 220px;
}

.table {
  width: 100%;
  font-size: 14px;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.avatar-uploader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  border-radius: 6px;
  border: 1px #cdcdcd dashed;
  height: 150px;
  cursor: pointer;
}

.avatar-uploader-icon {
  font-size: 26px;
}

.avatar {
  width: 150px;
  height: 150px;
  border-radius: 6px;
}

/* 手机端适配 */
@media (max-width: 767px) {
  .user-page {
    height: calc(100vh - 56px);
  }
  .handle-box {
    flex-direction: column;
    align-items: stretch;
  }
  .search-input {
    width: 100%;
  }
  .mc-avatar-placeholder {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f7fa;
    border-radius: 6px;
    color: #c0c4cc;
    font-size: 20px;
  }
}

/* 平板端适配 */
@media (min-width: 768px) and (max-width: 1024px) {
  .user-page {
    height: calc(100vh - 56px);
  }
  .search-input {
    width: 180px;
  }
}
</style>